import { useState } from 'react';
import { Card, Input, Select, Button } from '@getpay93/ui';
import { usePlans, useCreateInvite } from '../../data/hooks';
import type { InviteResponse } from '@getpay93/api';
import { money } from '../../lib/format';

export function Invitar() {
  const plans = usePlans();
  const create = useCreateInvite();
  const [clientName, setClientName] = useState('');
  const [planId, setPlanId] = useState('');
  const [days, setDays] = useState('14');
  const [result, setResult] = useState<InviteResponse | null>(null);
  const [copied, setCopied] = useState(false);

  function generate() {
    create.mutate(
      { clientName: clientName || undefined, planId: planId || undefined, expiresInDays: Number(days) || 14 },
      { onSuccess: (inv) => { setResult(inv); setCopied(false); } },
    );
  }

  const error = create.error instanceof Error ? create.error.message : null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 480 }}>
      <Card>
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: 'var(--text-strong)' }}>Invitar cliente</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 12 }}>
          <Input placeholder="Nombre del cliente (opcional)" value={clientName} onChange={(e) => setClientName(e.currentTarget.value)} />
          <Select label="Plan (opcional)" options={[{ value: '', label: 'Sin plan' }, ...(plans.data ?? []).map((p) => ({ value: p.id, label: `${p.name} · ${money(p.price)}` }))]} value={planId} onChange={(e) => setPlanId(e.currentTarget.value)} />
          <Input label="Expira en (días)" type="number" value={days} onChange={(e) => setDays(e.currentTarget.value)} />
          {error ? <p style={{ margin: 0, color: 'var(--status-overdue)', fontSize: 13, fontWeight: 600 }}>{error}</p> : null}
          <Button onClick={generate} disabled={create.isPending}>{create.isPending ? 'Generando…' : 'Generar invitación'}</Button>
        </div>
      </Card>

      {result ? (
        <Card>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.08em', color: 'var(--text-hint)' }}>Código</div>
          <div style={{ fontSize: 28, fontWeight: 800, letterSpacing: '.1em', color: 'var(--brand-green)' }}>{result.code}</div>
          <div style={{ marginTop: 12, display: 'flex', gap: 8, alignItems: 'center' }}>
            <Input readOnly value={result.shareUrl} containerStyle={{ flex: 1 }} />
            <Button variant="outline" iconLeft="copy" onClick={() => { void navigator.clipboard?.writeText(result.shareUrl); setCopied(true); }}>{copied ? 'Copiado' : 'Copiar'}</Button>
          </div>
        </Card>
      ) : null}
    </div>
  );
}
